export default function MacrosMenu({
  renderMacrosMenu
}) {
  return renderMacrosMenu();
}
MacrosMenu.displayName = 'MacrosMenu';